document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.lpan-header-transparent');
  
  // Fondo al scroll
  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  });
});